module.exports = __webpack_public_path__ + "img/search-empty.38e2ac42.png";